// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__2GrBV","layout_content":"Layout_layout_content__hcyU3"};